import { createApi } from "@reduxjs/toolkit/dist/query/react"
import { getQueryString } from "../../common/utils"
import { FIND_OB_LO_ENDPOINT } from "../../common/constants"
import { OBLOResult, CustomFieldsResponse } from "../../types/pricing-engine"
import { baseQuery } from "../api"

const reducerPath = "pricingEngine"

export const pricingEngineApi = createApi({
  reducerPath,
  baseQuery,
  tagTypes: ["ob-los", "custom-fields"],
  endpoints: builder => ({
    findOBLOs: builder.query<OBLOResult[], { name?: string; brand_id: string }>(
      {
        query: params => `${FIND_OB_LO_ENDPOINT}${getQueryString(params)}`,
        transformResponse: (responseData: OBLOResult[]) => responseData ?? [],
        providesTags: ["ob-los"]
      }
    ),
    clearOBCache: builder.mutation<void, void>({
      query: () => ({
        url: `${FIND_OB_LO_ENDPOINT}?reset_cache=1`,
        method: "GET"
      }),
      invalidatesTags: ["ob-los"]
    }),
    getCustomFields: builder.query<
      CustomFieldsResponse,
      { rateflow_id: string }
    >({
      query: params => `/api/v1/custom-fields${getQueryString(params)}`,
      providesTags: ["custom-fields"]
    })
  })
})

export const {
  useFindOBLOsQuery,
  useLazyFindOBLOsQuery,
  useClearOBCacheMutation,
  useGetCustomFieldsQuery
} = pricingEngineApi
